<script setup lang="ts">
import type Article from "~~/types/Article";

const props = defineProps({
    article: {
        type: Object as PropType<Article>,
        required: false,
    },
});
</script>

<template>
    <div class="bg-abc-gray py-10">
        <div class="container lg:flex">
            <div
                class="flex flex-none items-center justify-center bg-[url(/images/home/zone4_bg_530x360.svg)] bg-cover bg-center bg-no-repeat p-4 lg:h-80 lg:w-1/2 lg:bg-auto"
            >
                <NuxtLink :to="`/articles/${article?.slug}`">
                    <img
                        :src="article?.photo_lg"
                        :alt="'Cover Image'"
                        class="w-full overflow-hidden rounded-2xl object-cover lg:w-3/4"
                    />
                </NuxtLink>
            </div>
            <div class="flex-1 pt-4">
                <h1 class="mb-4 text-4xl font-bold">{{ article.title }}</h1>
                <div class="mb-4">{{ article.excerpt }}</div>
                <ButtonSecondary
                    type="link"
                    :href="`/articles/${article?.slug}`"
                    class="w-full md:w-auto"
                    >Continue Reading
                </ButtonSecondary>
            </div>
        </div>
    </div>
</template>
